import { apiBaseUrl } from './config';

const baseUrl = `${apiBaseUrl}/services`;

export async function getServices() {
  const r = await fetch(`${baseUrl}/`);
  if (!r.ok) throw { status: r.status };
  return r.json();
}

export async function getAdminServices(token) {
  const r = await fetch(`${baseUrl}/admin`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!r.ok) throw { status: r.status };
  return r.json();
}

export async function createService(token, fields) {
  const r = await fetch(`${baseUrl}/admin`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(fields)
  });
  const data = await r.json();
  if (!r.ok) throw data;
  return data;
}

export async function updateService(token, serviceId, updates) {
  const r = await fetch(`${baseUrl}/admin/${serviceId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(updates)
  });
  const data = await r.json();
  if (!r.ok) throw data;
  return data;
}

export async function uploadServiceImage(token, serviceId, imageFile) {
  const formData = new FormData();
  formData.append('image', imageFile);
  const r = await fetch(`${baseUrl}/admin/${serviceId}/image`, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${token}` },
    body: formData
  });
  const data = await r.json();
  if (!r.ok) throw data;
  return data;
}
